import React from 'react';

const Logo = ({ width = 40, height = 40, showText = true }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <img 
        src="/fluxcore-logo.png" 
        alt="FluxCore Technology Logo" 
        width={width} 
        height={height}
        style={{ objectFit: 'contain' }}
      />
      
      {showText && (
        <span className="logo-text">FluxCore Technology</span>
      )}
    </div>
  );
};

export default Logo;
